"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMapIcon = void 0;
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _mapIconInfo = require("./mapIconInfo");
/**
 * Based on icon type and if it is selected will return data needed for generating icon
 * @param data MapIconProps
 * @returns mapData (width, height, v-box, color, inner color, shadow x & y)
 */
const useMapIcon = data => {
  const theme = (0, _mui.useTheme)();
  const {
    iconType,
    isSelected,
    clusterSize
  } = data;

  // Parse clusterSize and validate for cluster icon
  const validCluster = (0, _react.useMemo)(() => {
    if (iconType === 'cluster' && typeof clusterSize === 'string') {
      // Accept: string number >= 2, or string like '17+', '99+' etc
      if (/^\d+$/.test(clusterSize)) {
        // Pure number string
        return Number.parseInt(clusterSize, 10) >= 2;
      } else if (/^\d+\+$/.test(clusterSize)) {
        // Pattern like '99+'
        return true;
      }
    }
    return false;
  }, [clusterSize, iconType]);
  const mapData = {
    width: _mapIconInfo.mapIconInfo.pin.width,
    height: _mapIconInfo.mapIconInfo.pin.height,
    vBox: `0 0 ${_mapIconInfo.mapIconInfo.pin.width} ${_mapIconInfo.mapIconInfo.pin.height}`,
    color: theme.palette.default.main,
    innerColor: theme.palette.common.white,
    shadowX: 0,
    shadowY: 0,
    iconType: iconType === 'cluster' ? 'pin' : iconType,
    clusterSize: undefined
  };
  if (isSelected) {
    mapData.width = _mapIconInfo.mapIconInfo.pinSelected.width;
    mapData.height = _mapIconInfo.mapIconInfo.pinSelected.height;
    mapData.color = theme.palette.primary.dark;
  }
  if (iconType === 'cluster' && validCluster) {
    mapData.iconType = 'cluster';
    mapData.width = _mapIconInfo.mapIconInfo.cluster.width;
    mapData.height = _mapIconInfo.mapIconInfo.cluster.height;
    mapData.vBox = `0 0 ${_mapIconInfo.mapIconInfo.cluster.width} ${_mapIconInfo.mapIconInfo.cluster.height}`;
    mapData.shadowX = 0.246033;
    mapData.shadowY = 0.0297852;
    mapData.clusterSize = clusterSize;
  }
  if (iconType === 'currentLocation') {
    mapData.width = _mapIconInfo.mapIconInfo.currentLocation.width;
    mapData.height = _mapIconInfo.mapIconInfo.currentLocation.height;
    mapData.vBox = `0 0 ${_mapIconInfo.mapIconInfo.currentLocation.width} ${_mapIconInfo.mapIconInfo.currentLocation.height}`;
    mapData.color = theme.palette.info.dark;
  }
  return {
    mapData
  };
};
exports.useMapIcon = useMapIcon;
